// MUI
import { Box, Alert, AlertTitle, Typography } from "@mui/material";
// Styles
import { styles } from "../styles";
// Libraries
import { useTranslation } from "react-i18next";

const NoAppointmentsText = ({
  failedClinics = [],
  totalClinics = 0,
  locationName,
}) => {
  const { t } = useTranslation();

  if (failedClinics.length === 0) return null;

  const sortedFailedClinics = [...failedClinics].sort((a, b) => {
    const nameA = t("clinic.name", { clinic: a.Clinic }).toLowerCase();
    const nameB = t("clinic.name", { clinic: b.Clinic }).toLowerCase();

    return nameA.localeCompare(nameB, "fr", { sensitivity: "base" });
  });

  const allFailed = totalClinics > 0 && failedClinics.length === totalClinics;
  const headerKey = allFailed
    ? "availableAppointments.failedAvailableAppointments.locationLevelError"
    : "availableAppointments.failedAvailableAppointments.clinicLevelError";

  return (
    <Alert severity="warning" sx={styles.noAppointmentsText}>
      <Box>
        <AlertTitle sx={{ textAlign: "left" }}>
          {t(headerKey, { location: locationName })}
        </AlertTitle>

        {!allFailed && (
          <Box component="ul" sx={{ textAlign: "left" }}>
            {sortedFailedClinics.map((clinic) => (
              <Box component="li" key={clinic.id}>
                <Typography variant="body2">
                  {t("clinic.name", { clinic: clinic.Clinic })}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Alert>
  );
};

export default NoAppointmentsText;
